<template>
  <div class="admin-page__content">
    <form>
      <div class="d-flex align-items-center justify-content-between">
        <h2 class="mb-0">
          {{ $t("novyProjekt") }}
        </h2>
        <button
          class="btn btn-primary d-flex align-items-center justify-content-center"
        >
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozitZmeny") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
//import axios from "axios";
//import Back from "@/components/back.vue";
//import Select from "@/components/inputs/select.vue";
//import Menu from "@/components/admin/project/menu.vue";
export default {
  components: {
    //"app-back": Back,
    //"project-menu": Menu,
    //"custom-select": Select
  },
  props: {
    project: Object
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
